jQuery(document).ready(function ($) {
    const heroBackgroundSlider = new Swiper('.js-hero-background', {
        loop: true,

        slidesPerView: 1,

        crossFade: true,
        effect: 'fade',
        noSwiping: true,
        noSwipingClass: 'hero__slider',
        longSwipes: false,

        pagination: {
            el: '.hero__pagination',
            type: 'bullets',
            bulletClass: 'pagination__bullet',
            bulletActiveClass: 'active',
            clickable: true
        },

        autoplay: true,
        delay: 4000,
        speed: 750,
    });
});